import React from "react";

import "./styles.css";

import FileCopyIcon from "@material-ui/icons/FileCopy";

import AddIcon from "@material-ui/icons/Add";
import { useSetRecoilState } from "recoil";
import { popupState } from "../../Store/atoms";
import { PopupType } from "../../Models/Entities";
export default () => {
  const setPopup = useSetRecoilState(popupState);

  const createFromExisting = () => {
    setPopup({ type: PopupType.AddFavorite, props: null });
  };

  const uploadExisting = () => {
    setPopup({ type: PopupType.UploadTable, props: null });
  };

  const createNew = () => {
    setPopup({ type: PopupType.CreateTable, props: null });
  };

  return (
    <div className="create-codetable-container">
      <div className="create-codetable">
        <div className="create-codetable__option" onClick={createFromExisting}>
          <FileCopyIcon style={{ fontSize: "10rem" }} />

          <div className="create-option__description">
            Create new from existing codetable
          </div>
        </div>
        <div className="create-codetable__option" onClick={createNew}>
          <AddIcon style={{ fontSize: "10rem" }} />
          <div className="create-option__description">
            Create new from scratch
          </div>
        </div>
        <div className="create-codetable__option" onClick={uploadExisting}>
          <AddIcon style={{ fontSize: "10rem" }} />
          <div className="create-option__description">
            Upload existing table
          </div>
        </div>
      </div>
    </div>
  );
};
